export enum OperatingSystem {
  MACOS = 'MACOS',
  WINDOWS = 'WINDOWS',
  LINUX = 'LINUX',
}

export const operatingSystemInfo: Record<
  OperatingSystem,
  {
    name: string;
    deviceName: string;
  }
> = {
  [OperatingSystem.MACOS]: {
    name: 'macOS',
    deviceName: 'Mac',
  },
  [OperatingSystem.WINDOWS]: {
    name: 'Windows',
    deviceName: 'Windows',
  },
  [OperatingSystem.LINUX]: {
    name: 'Linux',
    deviceName: 'Linux',
  },
};
